import {detailOfferListConstraints} from "../../../offer/constants/detail_offer_list_constraints";
import {getOfferListSortName} from "../../../offer/helpers/get_offer_list_sort_name";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {SearchSortString} from "../../../offer/list/constants/SearchSort";
import {IGetOfferListPayload} from "../../../offer/types/GetOfferListPayload";
import {OfferType} from "../../../offer/types/OfferType";

export const PRICES_HUB_OFFERS_PAGE_SIZE = 8;
const PRICES_REGION_OFFERS_PAGE_SIZE = 5;

// Shared by the carousels and their server prefetch - the RTK Query cache key is built from this object,
// so any drift between the two would make the browser fetch the list again on hydration.
export const getPricesHubOffersQuery = (regionId: number | null): IGetOfferListPayload => ({
    page: 1,
    page_size: PRICES_HUB_OFFERS_PAGE_SIZE,
    sort: getOfferListSortName(SearchSortString.PRICE_M2, false),
    type: OfferType.FLAT,
    display_type: OfferDisplayType.FOR_SALE,
    for_sale: true,
    show_on_listing: true,
    limited_presentation: false,
    ...(regionId ? {region: regionId, distance: 0} : {})
});

export const getPricesRegionOffersQuery = (regionId: number, offerType: OfferType): IGetOfferListPayload => ({
    page: 1,
    page_size: PRICES_REGION_OFFERS_PAGE_SIZE,
    ...detailOfferListConstraints,
    type: offerType,
    distance: 0,
    region: regionId,
    sort: getOfferListSortName(SearchSortString.PRICE_M2, false)
});
import {detailOfferListConstraints} from "../../../offer/constants/detail_offer_list_constraints";
import {getOfferListSortName} from "../../../offer/helpers/get_offer_list_sort_name";
import {OfferDisplayType} from "../../../offer/helpers/OfferDisplayType";
import {SearchSortString} from "../../../offer/list/constants/SearchSort";
import {IGetOfferListPayload} from "../../../offer/types/GetOfferListPayload";
import {OfferType} from "../../../offer/types/OfferType";

export const PRICES_HUB_OFFERS_PAGE_SIZE = 8;
const PRICES_REGION_OFFERS_PAGE_SIZE = 5;

// Shared by the carousels and their server prefetch - the RTK Query cache key is built from this object,
// so any drift between the two would make the browser fetch the list again on hydration.
export const getPricesHubOffersQuery = (regionId: number | null): IGetOfferListPayload => ({
    page: 1,
    page_size: PRICES_HUB_OFFERS_PAGE_SIZE,
    sort: getOfferListSortName(SearchSortString.PRICE_M2, false),
    type: OfferType.FLAT,
    display_type: OfferDisplayType.FOR_SALE,
    for_sale: true,
    show_on_listing: true,
    limited_presentation: false,
    ...(regionId ? {region: regionId, distance: 0} : {})
});

export const getPricesRegionOffersQuery = (regionId: number, offerType: OfferType): IGetOfferListPayload => ({
    page: 1,
    page_size: PRICES_REGION_OFFERS_PAGE_SIZE,
    ...detailOfferListConstraints,
    type: offerType,
    distance: 0,
    region: regionId,
    sort: getOfferListSortName(SearchSortString.PRICE_M2, false)
});
